import { Grid2, Button, Typography } from '@mui/material';
import { IComponentCss } from '@tap/mui-ui';

/*
*   Заглушка для отчетов при отсутствии результата
*/

const css: IComponentCss = {
    contentWrap: {
        minHeight: '75vh',
    },
    textWrap: {
        textAlign: 'center',
    },
    returnButton: {
        height: '37px',
        marginTop: '5px',
        textTransform: 'none',
    },
};


export function NotDataForReportPage({ onReturnButtonClick }: { onReturnButtonClick: () => void }) {
    return (
        <Grid2
            container
            alignItems='center'
            justifyContent='center'
            sx={css.contentWrap}
        >
            <Grid2 sx={css.textWrap}>
                <Typography sx={{ mb: 2 }}>
                    Для указанных параметров нет данных для отображения
                </Typography>

                <Button
                    variant='text'
                    onClick={onReturnButtonClick}
                    sx={css.returnButton}
                >
                    Назад
                </Button>
            </Grid2>
        </Grid2>
    );
}
